export enum ApplicationType {
    Pump,
    Fan
}
